<template lang="pug">
.purchaseModalProductComponent(
  v-if="model"
  :class="productClasses"
  @click="onClick"
)
  .top
    .image(:style="imageStyles")
    .name {{ model.name }}
    .price {{ model.price }}₽/ год
  .description(v-if="model.description" v-html="model.description")
  .items(v-if="model.items?.length")
    .item(v-for="item in model.items")
      .name(v-if="item.name") {{ item.name }}
      .authors(v-if="item.authors") {{ item.authors }}
  .divider
  .subscription(v-if="subscriptionExpiresText")  {{ subscriptionExpiresText }}
  .checkbox(v-if="isCheckboxVisible")
    ui-checkbox(
      :label-text="isPurchased ? 'Продлить подписку' : 'Выбрать подписку'"
      :is-decorative="true"
      :value="isSelected"
    )
</template>

<script>
import { computed } from 'vue'
import moment from 'moment'
export default {
  props: {
    model: {
      type: Object,
      default: null
    },
    isSelected: Boolean,
    isPurchased: Boolean,
    subscriptionExpires: {
      type: String,
      default: null
    }
  },
  emits: ['select'],
  setup (props, { emit }) {
    const productClasses = computed(() => {
      return {
        _selected: props.isSelected,
        _purchased: props.isPurchased
      }
    })

    const imageStyles = computed(() => {
      return {
        backgroundImage: `url('${props.model.image}')`
      }
    })

    const subscriptionExpiresText = computed(() => {
      return props.isPurchased && props.subscriptionExpires ? `Подписка активна до ${moment(props.subscriptionExpires).format('DD.MM.YYYY')}` : null
    })

    const isCheckboxVisible = computed(() => {
      let daysLeft = -1
      if (props.subscriptionExpires) {
        const dateNow = moment()
        daysLeft = -dateNow.diff(moment(props.subscriptionExpires), 'days')
      }
      return !props.isPurchased || daysLeft <= 30
    })

    const onClick = () => {
      if (!props.isPurchased) {
        emit('select')
      }
    }

    return { productClasses, imageStyles, subscriptionExpiresText, onClick, isCheckboxVisible }
  }
}
</script>

<style lang="sass" scoped>
.purchaseModalProductComponent
  padding: 5*$u
  background-color: $cWhite
  border: .5*$u solid $cDarkBackground
  border-radius: $brM
  width: 88*$u
  height: 100%
  display: flex
  flex-direction: column

  &:hover:not(._purchased),
  &._selected
    background-color: $cBackground
    cursor: pointer

  > .top
    display: grid
    grid-template-areas: "image name" "image price"
    grid-template-columns: 25*$u 1fr
    grid-gap: 1*$u 3*$u
    margin-bottom: 4*$u

    > .image
      width: 25*$u
      height: 25*$u
      background: center no-repeat
      background-size: contain
      grid-area: image
      align-self: center

    > .name
      grid-area: name
      @include font(t16-medium)
      align-self: end

    > .price
      grid-area: price
      @include font(t18-demibold)
      align-self: start

  > .description
    @include font(t16-regular)
    margin-bottom: 3*$u

  > .items
    margin-bottom: 3*$u

    > .item
      position: relative
      padding-left: 5*$u

      &::before
        content: ''
        width: 2*$u
        height: 2*$u
        border-radius: 50%
        background-color: $cGreen
        position: absolute
        top: 2*$u
        left: 0

      &:not(:last-child)
        margin-bottom: 1*$u
      > .name
        @include font(t16-regular)
      > .authors
        @include font(t16-regular)
        color: $cDarkGrey

  > .divider
    margin-top: auto
    margin-bottom: 3*$u
    height: .5*$u
    background-color: $cDarkBackground

  > .subscription
    color: $cDarkGrey
    @include font('t16-regular')
    margin-bottom: 2*$u
</style>
